<template>
  <div class="page-wrapper">
    <!-- Tabs Wrapper -->
    <div class="tabs-wrapper">
      <b-tabs lazy>
        <template #tabs-end>
          <div class="tabs-header-actions">
            <button
              v-if="getUserBrandPermissions.invoice_exact_export"
              class="action-btn export-btn"
              @click="showExportModal = true"
            >
              <v-icon name="file-download"></v-icon>
              {{ $t("globals.export_exact") }}
            </button>
            <button
              v-if="getUserBrandPermissions.invoice_exact_import"
              class="action-btn import-btn"
              @click="showImportModal = true"
            >
              {{ $t("globals.import_exact") }}
            </button>
          </div>
        </template>

        <b-tab :title="$t('globals.invoices')" active>
          <ulu-invoices-tab />
        </b-tab>
        <b-tab title="Mollie">
          <ulu-mollie-tab />
        </b-tab>
        <b-tab :title="$t('globals.parking_invoices')">
          <ulu-parking-invoices-tab />
        </b-tab>
        <b-tab :title="$t('globals.scheduled_invoices')">
          <ulu-sheduled-invoices-tab />
        </b-tab>
      </b-tabs>
    </div>

    <ulu-export-exact-modal :show="showExportModal" :close="closeExportModal" />
    <ulu-import-exact-modal :show="showImportModal" :close="closeImportModal" />
    <ulu-import-parking-exact-modal
      :show="showParkingImportModal"
      :close="closeParkingImportModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "vue-awesome/icons/file-download";

export default {
  components: {
    "ulu-invoices-tab": () =>
      import("@/components/invoices/all_invoices/InvoicesTab"),
    "ulu-mollie-tab": () =>
      import("@/components/invoices/all_invoices/MollieTab"),
    "ulu-parking-invoices-tab": () =>
      import("@/components/invoices/all_invoices/ParkingInvoicesTab"),
    "ulu-sheduled-invoices-tab": () =>
      import("@/components/invoices/all_invoices/SheduledInvoicesTab"),
    "ulu-export-exact-modal": () =>
      import("@/components/invoices/all_invoices/ExportExactModal"),
    "ulu-import-exact-modal": () =>
      import("@/components/invoices/all_invoices/ImportExactModal"),
    "ulu-import-parking-exact-modal": () =>
      import("@/components/invoices/all_invoices/ImportParkingExactModal")
  },
  data() {
    return {
      showExportModal: false,
      showImportModal: false,
      showParkingImportModal: false
    };
  },
  methods: {
    closeExportModal() {
      this.showExportModal = false;
    },
    closeImportModal() {
      this.showImportModal = false;
    },
    closeParkingImportModal() {
      this.showParkingImportModal = false;
    }
  },
  computed: {
    ...mapGetters("invoices", [
      "getAllBillingInvoicesLoading",
      "getAllParkingInvoicesLoading"
    ]),
    ...mapGetters([
      "getUserSystem",
      "getUserBrandPermissions",
      "getAllScheduledInvoicesLoading"
    ])
  },
  created() {
    if (!this.getUserBrandPermissions.invoices_index) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>

